// Self-hosted variable fonts — no Google Fonts CDN, so the app renders
// correctly with no external network (CLAUDE.md §2.3).
import '@fontsource-variable/geist';
import '@fontsource-variable/geist-mono';

import './theme/tokens.css';
import './components/components.css';

import { mountApp } from './app/mount';

const container = document.getElementById('root');
if (container === null) {
  throw new Error('Docsight could not start: #root is missing from index.html');
}

mountApp(container);
